import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Router } from '@angular/router';

@Component({
  selector: 'front-end-fund-cash-purchase-confirm-transfer',
  templateUrl: './fund-cash-purchase-confirm-transfer.component.html',
  styleUrls: ['./fund-cash-purchase-confirm-transfer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FundCashPurchaseConfirmTransfertPage {
  constructor(
    private modalController: ModalController,
    private router: Router
  ) {}

  close() {
    this.modalController.dismiss();
    this.router.navigateByUrl('/home/fund-cash/draft');
  }
}
